module.exports = __webpack_public_path__ + "static/img/role-cn.4c335c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-5/role-cn.png
// module id = pV8r
// module chunks = 1